import { FC, useState } from 'react';

import { Button, Form, FormItem, Header, Input, ScrollView } from '$uikit';
import { useDispatch } from 'react-redux';
import { toastActions } from '$store/toast';
import { Api } from '$api';
import { goTo } from '$navigation/helper';
import { LIST } from '$shared/constants/pages';
import { useTranslator } from '$hooks';

export const NewList: FC = () => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const [name, setName] = useState('');

  const handleCreate = () => {
    const namePrepared = name.trim();
    if (!namePrepared.length) {
      dispatch(toastActions.setToastFail(t('new_list_empty_error')));
      return;
    }

    dispatch(toastActions.setToastLoading());
    Api.post<
      any,
      {
        listId: string;
      }
    >('/lists/create', {
      name: namePrepared,
    })
      .then((resp) => {
        dispatch(toastActions.setToastSuccess());
        goTo(
          LIST,
          {
            id: resp.listId,
          },
          {
            replace: true,
          },
        );
      })
      .catch((e) => {
        dispatch(toastActions.setToastFail(e.message));
      });
  };

  return (
    <>
      <Header showBackButton>{t('new_list_title')}</Header>
      <ScrollView>
        <Form>
          <FormItem>
            <Input
              placeholder={t('new_list_name_placeholder')}
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </FormItem>
          <FormItem>
            <Button onClick={handleCreate}>{t('new_list_submit')}</Button>
          </FormItem>
        </Form>
      </ScrollView>
    </>
  );
};
